import Typography from '@mui/material/Typography';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ $page?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(4)};

  height: 100%;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(2)};
  text-align: center;

  ${({ $page }) =>
    $page &&
    css`
      flex: 1;
    `};
`;

export const IconContainer = styled.span<{
  $large?: boolean;
  $page?: boolean;
}>`
  color: ${({ theme }) => theme.palette.grey[600]};
  font-size: 2.8rem;
  line-height: 62.5%;

  ${({ $page }) =>
    $page &&
    css`
      font-size: 4rem;
    `};

  ${({ $large }) =>
    $large &&
    css`
      font-size: 9.2rem;
    `};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  max-width: 27rem;
`;

export const Title = styled.span<{ $page?: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  text-align: center;

  ${({ $page, theme }) =>
    $page &&
    css`
      ${typographyToCss(theme.typography.h5)};
    `};
`;

export const Description = styled(Typography).attrs({ variant: 'body2' })`
  color: ${({ theme }) => theme.palette.text.secondary};

  a {
    color: inherit;
  }
`;

export const Interactions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;
